<template>
  <section class="banner_sec">
    <a :href="shopifyData.secLink ? shopifyData.secLink : '#'" :style="sectionStyles">
      <!-- Banner Content -->
      <div class="banner_content">
        <h1 class="banner_main_heading" :style="fontSize" v-html="shopifyData.heroHeading" />
        <div class="banner_img t-center">
          <img
            class="desktop_img"
            :src="shopifyData.heroImgDesktop"
            alt="Hero Image"
            :style="imageWidth"
          />
          <img
            class="mobile_img"
            :src="shopifyData.heroImgMobile"
            alt="Hero Image"
            :style="imageWidthMobile"
          />
        </div>
      </div>
    </a>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fontSizeStyles: {
        fontSize: '16px',
        lineHeight: '16px',
      },
    };
  },

  computed: {
    sectionStyles() {
      return {
        backgroundColor: this.shopifyData.bgColor || '#fff',
        paddingTop:
          window.innerWidth > 676
            ? (this.shopifyData.deskPaddingTop || '0') + 'px'
            : (this.shopifyData.mobPaddingTop || '0') + 'px',
        paddingBottom:
          window.innerWidth > 676
            ? (this.shopifyData.deskPaddingBottom || '0') + 'px'
            : (this.shopifyData.mobPaddingBottom || '0') + 'px',
      };
    },
    fontSize() {
      return this.fontSizeStyles;
    },
    imageWidth() {
      return {
        maxWidth: this.shopifyData.imageWidth ? this.shopifyData.imageWidth + 'px' : '100%',
      };
    },
    imageWidthMobile() {
      return {
        maxWidth: this.shopifyData.imageWidthMobile
          ? this.shopifyData.imageWidthMobile + '%'
          : '100%',
      };
    },
  },
  mounted() {
    // Initial call to set the fontSize
    this.updateFontSize();

    // Add a window resize event listener
    window.addEventListener('resize', this.updateFontSize);
  },
  beforeUnmount() {
    // Remove the window resize event listener when the component is destroyed
    window.removeEventListener('resize', this.updateFontSize);
  },
  methods: {
    updateFontSize() {
      const windowWidth = window.innerWidth;
      if (windowWidth >= 1200) {
        this.fontSizeStyles.fontSize = (this.shopifyData.deskFontSize || '16') + 'px';
        this.fontSizeStyles.lineHeight = (this.shopifyData.deskLineHeight || '16') + 'px';
      } else if (windowWidth <= 1200 && windowWidth >= 425) {
        // this.fontSizeStyles.fontSize = (this.shopifyData.mediumFontSize || '16') + 'px';
        // this.fontSizeStyles.lineHeight = (this.shopifyData.mediumLineHeight || '16') + 'px';
        this.fontSizeStyles.fontSize = 5 + 'vw';
        this.fontSizeStyles.lineHeight = 6 + 'vw';
      } else {
        this.fontSizeStyles.fontSize = (this.shopifyData.mobFontSize || '16') + 'px';
        this.fontSizeStyles.lineHeight = (this.shopifyData.mobLineHeight || '16') + 'px';
      }
    },
  },
};
</script>

<style scoped>
.banner_sec a {
  display: block;
}

.banner_main_heading {
  transform: translateY(35%);
  font-weight: 700;
  text-align: center;
  color: #000000;
}

.desktop_img {
  display: block;
  margin: 0 auto;
  width: 100%;
}

.mobile_img {
  display: none;
  width: 100%;
}

/* Responsive Breakpoints */
@media screen and (max-width: 767px) {
  .mobile_img {
    display: block;
    margin: 0 auto;
    max-width: 100%;
  }

  .desktop_img {
    display: none;
  }
}
</style>
